import './globals.js'
import $ from 'jquery'

import DataTable from 'datatables.net-bs4';
import 'datatables.net-fixedheader-dt';
import 'datatables.net-fixedcolumns-dt';
$.fn.DataTable = DataTable;

import "../src/datatables_init.js"

import Rails from "@rails/ujs"
Rails.start()

import 'bootstrap'
import "../src/bootstrap_init.js"

import "@hotwired/turbo-rails"

import LocalTime from "local-time"
LocalTime.config.i18n.en.datetime.formats.default = "%B %e, %Y at %l:%M:%S%P %Z"
LocalTime.start()

import "chartkick/chart.js"
import { Chart } from "chart.js"
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels)
Chart.defaults.set('plugins.datalabels', {
  display: false
});

// When a Turbo visit follows a server-side redirect, Turbo runs a second
// render pass to fix up browser history. That pass fires the same
// turbo:before-render hook Chartkick uses to destroy charts before a page
// change, but doesn't re-run the chart's inline creation script - so the
// chart never comes back. Re-run any chart script whose chart didn't
// survive the navigation.
document.addEventListener("turbo:load", function () {
  document.querySelectorAll("script").forEach(function (scriptElement) {
    var match = scriptElement.textContent.match(/new Chartkick\[[^\]]+\]\((".*?")/)
    if (!match) return

    var elementId = JSON.parse(match[1])
    if (elementId in Chartkick.charts) return

    var rerunScript = document.createElement("script")
    rerunScript.textContent = scriptElement.textContent
    scriptElement.replaceWith(rerunScript)
  })
})

import "../app/application.js"
import "../app/stripe_seller_add_card.js"
import "../app/stripe_seller_add_bank_account.js"
import "../app/stripe_buyer_setup_intent.js"

import "../controllers"

import "../src/chosen_init.js"

import "../src/ahoy.js"
import "../src/timeout_poll.js"
import "../src/date_range_picker.js"
import "../src/flatpickr.js"
import "../src/mapbox.js"
import "../src/market_sheet.js"
import "../src/deposits.js"
import "../src/selectall.js"
